// extracted by mini-css-extract-plugin
module.exports = {"content":"TasksByStatus_content__x7PcY","status":"TasksByStatus_status__f_VwF","status-dark":"TasksByStatus_status-dark__1s4mn","projects":"TasksByStatus_projects__1PT8i"};